import Vue from 'vue'
// import VueRouter from 'vue-router'; // Lectyre 285
import router from './router'
import VueResource from 'vue-resource'; // Lecture 301
import axios from 'axios' // Lecture 346

import App from './App.vue'
// import { routes } from './routes'; // Lecture 285
import store from './store/store'; // Lecture 290

import Vuelidate from 'vuelidate'; // Lecture 373

import VModal from 'vue-js-modal' // https://www.npmjs.com/package/vue-js-modal

import * as VueGoogleMaps from "vue2-google-maps"; // https://alligator.io/vuejs/vue-google-maps/
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAjRmYdMmC9yr1dP8Kqi7FPS_8_CsvT2qc",
    libraries: "places" // necessary for places input
  }
});

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Bugsnag.start({
  apiKey: '721b33bda4d05be7823e259c51a89e7a',
  plugins: [new BugsnagPluginVue()]
})

Bugsnag.getPlugin("vue").installVueErrorHandler(Vue);

// Vue.use(VueRouter); // Lecture 285
Vue.use(VueResource); // Lecture 301
Vue.use(Vuelidate); // Lecture 373
Vue.use(VModal) // https://www.npmjs.com/package/vue-js-modal

// Vue.http.options.root = 'https://vuejs-http-cf9e8.firebaseio.com/';
// NOT BEING USED
Vue.http.options.root = 'http://myrundash-env.3rwyrgii8a.us-east-2.elasticbeanstalk.com/api/';

Vue.filter('currency', (value) => { // Lecture 297
  return '$' + value.toLocaleString();
});

// https://stackoverflow.com/questions/44538110/how-to-format-numbers-in-vuejs
// http://numeraljs.com/
var numeral = require("numeral");
Vue.filter("twoDigits", function (value) { // Used for padding minutes with a zero if the minutes are a single digit
  return numeral(value).format("00");
});
Vue.filter("singleDecimalSeconds", function (value) { // Used for making seconds 1 decimal (2 looks kinda weird), also pads a zero
  return numeral(value).format("00.0");
});
Vue.filter("singleDecimal", function (value) { // Used for making something 1 decimal (good for actual distances)
  return numeral(value).format("0.0");
});
Vue.filter("noDecimals", function (value) { // Used for getting rid of decimals
  return numeral(value).format("0");
});

// https://vuejs.org/v2/guide/mixins.html#Global-Mixin
// https://stackoverflow.com/questions/42613061/vue-js-making-helper-functions-globally-available-to-single-file-components
Vue.mixin({
  methods: {
    convertTimeToSeconds(hours, minutes, seconds) {
      console.log('Converting time to seconds!!');
      let timeInSecs = null
      if (hours) { timeInSecs += hours * 3600 }
      if (minutes) { timeInSecs += minutes * 60 }
      if (seconds) { timeInSecs += seconds * 1 }
      return timeInSecs
    },
    convertSecondsToTime(totalSeconds) {
      // Convert the total running time in seconds to hours:minutes:seconds
      // https://stackoverflow.com/questions/6312993/javascript-seconds-to-time-string-with-format-hhmmss]
      // console.log(totalSeconds)
      if (totalSeconds) {
        let hours = Math.floor(totalSeconds / 3600)
        let minutes = Math.floor((totalSeconds - (hours * 3600)) / 60)
        let seconds = totalSeconds - (hours * 3600) - (minutes * 60)
        return { hours: hours, minutes: minutes, seconds: seconds }
      }
      else { return { hours: null, minutes: null, seconds: null } }
    },
    convertDistanceToMeters (distance, units) {
      if (distance) {
        if (units == 'km') {
          return distance * 1000
        }
        else if (units == 'mi') {
          return distance * 1609
        }
        else {
          return null
        }
      } else {
        return null
      }
    },
    // isNumberKey(evt){
    //   var charCode = (evt.which) ? evt.which : evt.keyCode
    //   if (charCode > 31 && (charCode < 48 || charCode > 57))
    //       return false;
    //   return true;
    // },
    checkInteger(userinput) {
      //
      // Using this function to check if a user has entered an integer in number fields and display an error message if not
      //

      // Don't want to show an error if the field is blank
      if (userinput == null || userinput == '') {
        return false
      }

      // https://stackoverflow.com/questions/1779013/check-if-string-contains-only-digits
      console.log(userinput)
      // console.log(Number.isInteger(userinput))
      // console.log(!isNaN(userinput)) // https://www.mkyong.com/javascript/check-if-variable-is-a-number-in-javascript/
      console.log(/^\d+$/.test(userinput))
      if (/^\d+$/.test(userinput)) {
        console.log('Is an integer!')
        return false
      }
      else {
        console.log('Is not an integer')
        return true
      }
    },
    checkDecimal(userinput) {
      //
      // Using this function to check if a user has entered a valid number in decimal fields and display an error message if not
      //

      // Don't want to show an error if the field is blank
      if (userinput == null || userinput == '') {
        return false
      }

      if (isNaN(userinput)) {
        return true // not a number
      }
      else {
        return false
      }
    },
    // https://stackoverflow.com/questions/8888491/how-do-you-display-javascript-datetime-in-12-hour-am-pm-format
    formatAMPM(date) { // Take a javascript date and spit out the time in AMPM format
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    djangotimeformatAMPM(djangotime) { // Take a django 24 hour time and return it in AMPM format
      var hours = djangotime.split(':')[0];
      var minutes = djangotime.split(':')[1];
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      // minutes = minutes < 10 ? '0'+minutes : minutes; // minutes are already padded in django time
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
  }
})

// Lecture 285
// const router = new VueRouter({
//   mode: 'history',
//   routes
// });

// axios.defaults.baseURL = 'http://127.0.0.1:8000' // Lecture 346, 348
// axios.defaults.baseURL = 'http://myrundash-env.3rwyrgii8a.us-east-2.elasticbeanstalk.com/'
axios.defaults.baseURL = 'https://api.myrundash.com/'
// const instance = axios.create({
//   baseURL: 'https://enginehire.io'
// })
// export default instance // This axios instance (axios-auth) can now be accessed anywhere

// Lecture 348
// axios.defaults.headers.common['Authorization'] = 'Token be692ab6b0453364c430535f238bac73c34a693a'
// axios.defaults.headers.common['Authorization'] = `Token store.getters.userToken`
// axios.defaults.headers.common['Authorization'] = 'Token ' + localStorage.getItem('token') // https://forum.vuejs.org/t/add-header-token-to-axios-requests-after-login-action-in-vuex/38834/2

// Lecture 349
// https://stackoverflow.com/questions/43051291/attach-authorization-header-for-all-axios-requests
axios.interceptors.request.use(config => {
  console.log('Request Interceptor', config)
  // console.log(store.state.userToken)
  console.log(localStorage.getItem('token'))
  if (localStorage.getItem('token')) {
    config.headers['Authorization'] = 'Token ' + localStorage.getItem('token')
  }
  return config
})

new Vue({
  el: '#app',
  router, // Lecture 285
  store, // Lecture 290
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js